export enum RES_FACULTY_DISPLAY {
  BANK_OPERATION = 'OPERACIONES CON BANCOS E INSTITUCIONES FINANCIERAS',
  CHECKS_OPERATION = 'OPERACIONES CON CHEQUES, LETRAS, PAGARES Y OTROS DOCUMENTOS MERCANTILES',
  COLLECT = 'COBRAR Y PERCIBIR',
  CONTRACTS_CELEBRATION = 'CELEBRACION DE CONTRATOS',
  CREDIT = 'CREDITOS',
  DERIVATIVES = 'DERIVADOS',
  DOCUMENT_SIGNATURE = 'FIRMA DE DOCUMENTOS Y RETIRO DE CORRESPONDENCIA',
  FOREIGN_TRADE_OPERATION = 'OPERACIONES DE COMERCIO EXTERIOR',
  GUARANTEES_CONSTITUTION = 'CONSTITUCION DE GARANTIAS',
  INSTITUTIONAL_REPRESENTATION = 'REPRESENTACION ANTE INSTITUCIONES',
  INSURANCE = 'SEGUROS',
  JUDICIAL_REPRESENTATION = 'REPRESENTACION JUDICIAL',
  MANDATES = 'MANDATOS',
  OBLIGATION_PAYMENT = 'PAGOS Y EXTINCION DE OBLIGACIONES',
  REGISTER_TRADEMARKS = 'REGISTRO DE MARCAS',
  SOCIETY_CONSTITUTION = 'CONSTITUCION DE SOCIEDADES',
  SOCIETY_REPRESENTATION = 'REPRESENTACION ANTE SOCIEDADES Y ASOCIACIONES',
  SELF_CONTRACT = 'AUTOCONTRATACION',
  WORK_CONTRACTS = 'CONTRATOS DE TRABAJO',
}

export type RES_FACULTY = keyof typeof RES_FACULTY_DISPLAY;
